import { forwardRef } from 'react'
import parse from 'html-react-parser'

const CheckBox = forwardRef(({ item, register }, ref) => {
    return (
        <div className="relative flex items-start my-5">
            <div className="flex items-center h-5">
                <input
                    data-input-name={item.name}
                    ref={ref}
                    {...register(item.name)}
                    id={item.name}
                    aria-describedby={item.name}
                    type="checkbox"
                    defaultChecked={false}
                    className="focus:bg-olh h-4 w-4 text-olm"
                />
            </div>
            <div className="ml-2 text-sm">
                <label
                    htmlFor={item.name}
                    className="font-medium text-gray-700">
                    {parse(item?.modifiedLabel || item.label)}
                    <p className="text-gray-500 font-normal">
                        {item.description && parse(item.description)}
                        {item.helperText && item.helperText}
                    </p>
                </label>
            </div>
        </div>
    )
})

// Click here to accept the
// <a
//     className="ml-1 underline hover:no-underline"
//     target="_blank"
//     href="https://openlettermarketing.com/terms-of-service/"
//     rel="noreferrer">
//     terms of service
// </a>
// .

CheckBox.displayName = 'CheckBox'

export default CheckBox
